@if (isLoading()) {
  <div class="global-loader-container">
    <div class="loader-content">
      <img src="assets/images/logo.png" alt="Logo" class="loader-logo" />

      <div class="dots-loader">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
    </div>
  </div>
}

<router-outlet />
